import { UploadFile } from 'antd/lib/upload/interface';
import { useCallback } from 'react';
import { useMutation } from 'react-fetching-library';
import { uploadService } from 'services/driverPortal';
import { ONE_DAY_EXPIRE_DATE } from 'utils/dateUtils';
import { getFileIds } from 'utils/findImagePath';
import { transformMutationResponseError } from 'utils/transformResponseError';

export function useUpdateExpireDateImages() {
  const { mutate } = useMutation(uploadService.updateExpireDateFile);

  const handleUpdateError = (filesResponse: any[]) => {
    const expireDateFileErrors = filesResponse.filter(file => file?.error);
    if (expireDateFileErrors.length === 0) {
      return { error: false };
    } else {
      for (const error of expireDateFileErrors) {
        transformMutationResponseError(error?.payload as any);
      }
      return { error: true };
    }
  };

  const updateByFiles = useCallback(
    async (files: UploadFile[], expireDate = ONE_DAY_EXPIRE_DATE()) => {
      const filesResponse = [];
      for (const file of files) {
        const { fileName } = file;
        const fileIds = getFileIds({ fileName });
        const response = await mutate({ fileId: fileIds[0], expireDate });
        filesResponse.push(response);
      }

      return handleUpdateError(filesResponse);
    },
    [],
  );

  const updateByFileIds = useCallback(
    async (fileIds: string[], expireDate = ONE_DAY_EXPIRE_DATE()) => {
      const filesResponse = [];
      for (const fileId of fileIds) {
        const response = await mutate({ fileId, expireDate });
        filesResponse.push(response);
      }

      return handleUpdateError(filesResponse);
    },
    [],
  );

  return { updateByFiles, updateByFileIds };
}
